import React, { useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import "../../styles/theme.scss"
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Paper, IconButton, Input, Button, Box } from '@mui/material';
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import TableN from "../../reusableComponents/components/generics/TableN"
import { formatDateForFr } from '../../utils/helper';
const StyledPaper = styled(Paper)(({ theme }) => ({
    ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
    ...theme.paper.header,
    fontSize: 600,
    padding: ".8rem",
}));
function ClaimHistory({data}) {
    const SignInSuccess = useSelector((state) => state);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageInfo, setPageInfo] = useState();

    
    const claimApprovalStatusMapping = {
        "-1": t("Rejected"),
        "1": t("Created"),
        "2": t("Waiting for Approval"),
        "3": t("Rework"),
        "4": t("Approved"),
    };
    const statusStyles = {
        "-1": { color: 'red' },
        "1": { color: 'blue' },
        "2": { color: 'gray' },
        "3": { color: 'orange' },
        "4": { color: 'green' }, 
    };
    const headers = () => {
        var h = [
            t("Utilisateur"),
            t("Commentaire"),
            t("Date")
        ];
        return h;
    };

    const filterClaims = (claims) => {
        let result = [];
        let previousStatus = null;
    
        claims.forEach(claim => {
            if (claim.status === 1 || claim.status === 4 || claim.status === 32) {
                // Avoid consecutive duplicates
                if (claim.status !== previousStatus) {
                    if (claim.status === 4) {
                        result.push({
                            user: claim.adjuster?.lastName || "",
                            comment: claim.requestPaymentComment || "",
                            date: claim.validityFrom ? formatDateForFr(claim.validityFrom) : "" 
                        });
                    }
                    if (claim.status === 1) {
                        result.push({
                            user: claim.adjuster?.lastName || "",
                            comment: t(claim.rejectionComment) || "",
                            date: claim.validityFrom ? formatDateForFr(claim.validityFrom) : "" 
                        });
                    }
                    if (claim.status === 32) {
                        result.push({
                            user: claim.adjuster?.lastName || "",
                            comment: t(claim.reworkReason) || "",
                            date: claim.validityFrom ? formatDateForFr(claim.validityFrom) : "" 
                        });
                    }
                }
                previousStatus = claim.status;
            }
        });
    
        return result;
    };

    const itemFormatters = () => {
        var row = [
            (claim) => claim.user,
            (claim) => claim.comment,
            (claim) => claim.date
        ];

        return row;
    };
    const handleRowDoubleClick = (rowData) => {
        console.log(rowData,'rowData');
        navigate(`/fosa/preautharizationForm/:id=${rowData.id}`);
    };

    const handleOpen = () => {

    };

    return (
        <Grid style={{margin:'10px'}}>
            <TableN
                headers={headers()}
                itemFormatters={itemFormatters()}
                items={filterClaims(data)}
                withSelection={"single"}
                withPagination={true}
                defaultPageSize={50}
                page={page}
                pageSize={pageSize}
                count={pageInfo}
                onChangePage={(event, newPage) => {
                    setPage(newPage);
                    // handleNavigation(newPage > page ? 'forward' : 'backward');
                }}
                // onChangeRowsPerPage={handleRowsPerPageChange}
                // onDoubleClick={handleRowDoubleClick}
            />
        </Grid>
    )
}

export default ClaimHistory